<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text padding-off align="center" :class="['py-4']">
            <color-palette @input="onInput" name="color-palette-1" :colors="colors" v-model="model" :class="['p-2']" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk>v-model: {{ model }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import colors from '../../helpers/color-picker-colors'
import methods from '../../mixins/methods'

export default {
  name: 'PageColorPalette',
  mixins: [
    methods
  ],
  data () {
    return {
      model: '#f44336'
    }
  },
  computed: {
    colors: () => {
      return colors.map(color => {
        return {
          color,
          hint: color
        }
      }).slice(0, 18)
    }
  },
  methods: {
    onInput ($event) {
      this.log('input', 'color-palette', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/color-palette.vue